import _ from 'lodash';
import React from 'react';
import { CarouselMobile, Margin, Text } from '../../components';
import {
  LifeAtGlossierComponent,
  lifeAtGlossierData,
  lifeAtGlossierImages,
} from './shared';

export const LifeAtGlossierMobile = () => {
  return (
    <Margin size={[6, 0, 6, 0]}>
      <Margin size={[6, 0]}>
        <Text textType="heading3">Life at Glossier</Text>
      </Margin>

      <CarouselMobile images={lifeAtGlossierImages}>
        {_.flow((lifeAtGlossierData) =>
          _.map(lifeAtGlossierData, (value, index) => {
            return <LifeAtGlossierComponent value={value} key={index} />;
          })
        )(lifeAtGlossierData)}
      </CarouselMobile>
    </Margin>
  );
};
